<template>
  <ModalConfirmationDialog
    v-bind="$attrs"
    v-on="$listeners"
    :name="name"
    :primaryActionLabel="'OK'"
    :secondaryActionLabel="'Cancel'"
    @before-open="beforeOpen"
    @click-primary="$emit('delete-survey', survey)"
    @click-secondary="close"
  >
    Are you sure you want to delete <span :style="style.name">{{ this.survey.name }}</span>?
  </ModalConfirmationDialog>
</template>

<script>
  import ModalConfirmationDialog
    from '@modules/v2/modal/modal-confirmation-dialog'
  import { DIALOG_NAMES } from '@js/constants'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DialogDeleteSurveyPrimary',
    inheritAttrs: false,
    components: {
      ModalConfirmationDialog,
    },
    data: function () {
      return {
        name: DIALOG_NAMES.DELETE_SURVEY_PRIMARY,
        survey: {},
        style: {
          name: {
            fontWeight: FontStyle.weight.xl,
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.name,
        {
          color: this.color.dark2(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      beforeOpen: function (e) {
        this.clearCache();
        this.survey = e.params.survey;
      },
      clearCache: function () {
        this.survey = {};
      },
      close: function () {
        this.clearCache();
        this.$modal.hide(this.name);
      },
    },
  };
</script>
